<template>
  <div id="ravenwareSite" ref="ravenwareSite" :style="userStyle">

    <div id="site-header">
      <div class="row">
        <div class="col-md-3" id="site-logo-wrap">
          <a href="/"><img src="resources/images/logos/uk_business_broadband_x300.png" alt="UK Business Broadband Logo" id="site-logo"></a>
          <p id="associated">Part of <a href="https://ukitnetworks.com/" target="_blank"><img src="resources/images/logos/uk_it_networks_x100.png" alt="UK IT Networks" id="associated-logo"></a></p>
        </div>
        <div class="col-md-9 menu-items">
          <div class="items">
            <a href="/home">Business Broadband</a>
            <a href="/ethernet">Leased Line</a>
            <a href="/about-us">About Us</a>
            <a href="/support">Help and Support</a>
            <a href="/partners">Partners</a>
          </div>
          <a href="/support" class="btn btn-ukit-secondary">Contact Us</a>
        </div>
      </div>
    </div>

    <div id="background-outer" style="background-image:url('resources/images/ukit_networks_business_broadband.png');">
      <div id="background-inner">

        <div id="site-hero">
          <h1>Ethernet Leased <br>Line Deals</h1>
          <h2>Compare the latest <span>high speed</span> Ethernet<br>deals available to UK businesses</h2>
          <h3>Enter Your Details To Get Started</h3>
        </div>

        <div id="greenFrame" ref="greenFrame">
          <div v-if="isLoading" id="loading" style="width: 100%;height: 100%;z-index: 2000;position: absolute;top: 0px;left: 0px;padding: 50px;">
            <loading :active.sync="isLoading" :can-cancel="false" :color="'#B9D253'" :is-full-page="false"></loading>
          </div>
          <zoom-center-transition>
            <div class="text-center pt-4" v-if="!quoteResult">
              <p>Retrieving Quotes. Please wait... </p>
            </div>
          </zoom-center-transition>
          <zoom-center-transition>
            <div class="pt-4" v-if="stage === 'enquiry'">
              <div class="row">
                <div class="col-md-8">
                  <v-form ref="enquiryForm" lazy-validation v-model="enquiryFormValid" class="bbc_zeroTop">
                    <v-container  class="bbc_zeroTop">
                      <v-row  class="bbc_zeroTop">
                        <v-col class="bbc_zeroTop" cols="12" md="12">
                          <div class="left-field">
                            <v-text-field required :rules="requiredRules" filled dense ref="authorisedContactFirstNameenq" v-model="order.authorisedContactFirstName" label="First Name"></v-text-field>
                          </div>
                          <div class="right-field">
                            <v-text-field required :rules="requiredRules" filled dense ref="authorisedContactLastNameenq" v-model="order.authorisedContactLastName" label="Last Name"></v-text-field>
                          </div>
                          <div class="left-field">
                            <v-text-field required :rules="requiredRules" filled dense ref="companyName" v-model="order.companyName" label="Company Name" ></v-text-field>
                          </div>
                          <div class="right-field">
                            <v-text-field required :rules="requiredRules" filled dense ref="phoneNumberenq" v-model="order.phoneNumber" label="Phone Number" ></v-text-field>
                          </div>
                          <v-text-field required :rules="requiredRules" filled dense ref="emailAddressenq" v-model="order.emailAddress" label="Email Address" ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row class="bbc_zeroTop" style="margin-bottom:24px;">
                        <v-col class="bbc_zeroTop " offset="4" cols="12" md="12">
                         <vue-recaptcha @verify="verifyCaptcha" :loadRecaptchaScript="true" sitekey="6LdiF-IZAAAAADEsRPYbWcIGf3FssZBcFcKT3pKk">
                         </vue-recaptcha>
                        </v-col>
                      </v-row>
                      <div style="text-align:center;">
                        <v-btn v-if="vid" class="btn btn-ukit-secondary btn-sm" style="color:#fff;" @click="sendEnquiry()">Send Enquiry</v-btn>
                        <v-btn v-if="!vid" disabled="disabled" class="disabled btn btn-ukit-secondary btn-sm">Send Enquiry</v-btn>
                      </div>
                    </v-container>
                  </v-form>
                </div>
                <div class="col-md-4 pr-4">
                  <div class="card p-2">
                    <h4 class="text-ukit-primary text-center">Your Enquiry</h4>
                    <table class="table table-striped">
                      <tbody>
                        <tr>
                          <td colspan="2" class="text-center"><strong>{{ order.selectedResult.productName }}</strong></td>
                        </tr>
                        <tr v-if="order.selectedResult.showSpeed">
                          <td>Speed</td>
                          <td>
                            <span v-if="order.selectedResult.productName.includes('EFM')">{{ order.selectedResult.linecdr }}</span>
                            <span v-else>{{ order.selectedResult.linecdr }}/{{ order.selectedResult.bearer }}</span>
                          </td>
                        </tr>
                        <tr>
                          <td>Contract Term</td>
                          <td>{{ order.selectedResult.contractTermMonths }} Months</td>
                        </tr>
                        <tr>
                          <td>Install Charge</td>
                          <td>
                            <span v-if="order.selectedResult.installationCharge !== 0">£{{ order.selectedResult.installationCharge }}</span>
                            <span v-if="order.selectedResult.installationCharge === 0" class="text-ukit-primary">INCLUDED</span>
                          </td>
                        </tr>
                        <tr>
                          <td>Total Monthly Cost</td>
                          <td>£{{ toTwoDecimalPlaces(order.totalMonthlyCost) }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <button v-on:click="backToResults()" class="btn btn-ukit-secondary btn-block ">Back to Results</button>
                  </div>
                </div>
               </div>
            </div>
          </zoom-center-transition>
          <zoom-center-transition>
            <div class="pt-4" v-if="stage === 'enquireOrOrder'">
              <h2 class="text-center">Request more information or place order now?</h2>
              <div class="row p-4">
                <div class="col-md-6 pl-2">
                  <div v-on:click="selectEnquiry()" class="card enquireOrOrdeBox">
                    <div class="card-body text-center ">
                      <h2 style="font-weight: 600; font-size: 25px;" class="text-ukit-primary">Enquiry</h2>
                      <p>If you would like more information regarding this ethernet connection then please simply enquire here</p>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 pr-2">
                  <div v-on:click="selectOrder()" class="card enquireOrOrdeBox">
                    <div class="card-body text-center">
                      <h2 style="font-weight: 600; font-size: 25px;" class="text-ukit-secondary">Order</h2>
                      <p>Complete your order online here. Your order will be processed and confirmation will be emailed to you</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </zoom-center-transition>
          <zoom-center-transition>
            <div id="thankyou" class="text-center" v-if="stage === 'thankyou'">
              <div class="row">
                <div class="col-md-10 offset-md-1">
                  <h4>Thank you for placing your order for {{ order.selectedResult.productName }} with us .</h4>
                  <p>An email has been sent to {{ order.emailAddress }} to confirm your order.</p>
                  <p>Your order for services will be reviewed for acceptance and then processed within the next business day. Once validated we will confirm that we have accepted your order. Any questions please don't hesitate to call us on:  <strong class="text-ukit-primary">{{ clientSettings.contactNumber }}</strong></p>
                </div>
              </div>
            </div>
          </zoom-center-transition>
          <zoom-center-transition>
            <div id="thankyouEnquiry" class="text-center" v-if="stage === 'thankyouEnquiry'"  >
              <div class="row">
                <div class="col-md-10 offset-md-1">
                  <h4>Thank you for placing your enquiry for {{ order.selectedResult.productName }} with us.</h4>
                  <p>An email has been sent to {{ order.emailAddress }} to confirm your order.</p>
                  <p>Your enquiry will be reviewed and we will contact you shortly. If the enquiry is urgent or you have any questions please don't hesitate to call us on: <strong class="text-ukit-primary">{{ clientSettings.contactNumber }}</strong></p>
                </div>
              </div>
            </div>
          </zoom-center-transition>
          <zoom-center-transition>
            <div v-if="stage === 'wizard'">
              <div class="row">
                <div class="col-md-8">
                  <v-stepper v-model="currentStep">
                    <v-stepper-header>
                        <v-stepper-step :complete="e1 > 1" step="1" > <span class="ml-2">Your Details</span></v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="e1 > 2" step="2" > <span class="ml-2">Installation</span></v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="e1 > 3" step="3" > <span class="ml-2">Confirm Order</span></v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step step="4"> <span class="ml-2">Agreement</span></v-stepper-step>
                    </v-stepper-header>
                    <v-stepper-items>
                      <v-stepper-content step="1">
                        <div>
                          <v-form ref="detailsForm" lazy-validation v-model="detailsFormValid" class="bbc_zeroTop">
                            <v-container class="bbc_zeroTop">
                              <v-row class="bbc_zeroTop">
                                <v-col class="bbc_zeroTop" cols="12" md="12">
                                  <div v-if="quoteResult.clientSettings.enableExistingCustomer">
                                    <div class="mr-4" style="float:left;">
                                      <h4 v-bind:class="{'text-muted': !order.existingCustomer}">Existing Customer</h4>
                                    </div>
                                    <div>
                                      <a-switch style="margin-top: 20px;" size="small" @change="toggleExistingCustomer()" />
                                    </div>
                                  </div>
                                  <br>
                                  <div v-if="order.existingCustomer === true">
                                    <div class="left-field">
                                      <v-text-field required :rules="requiredRules" filled dense ref="authorisedContactFirstName" v-model="order.authorisedContactFirstName" label="First Name" ></v-text-field>
                                    </div>
                                    <div class="right-field">
                                      <v-text-field required :rules="requiredRules" filled dense ref="authorisedContactLastName" v-model="order.authorisedContactLastName" label="Last Name" ></v-text-field>
                                    </div>
                                    <div class="left-field">
                                      <v-text-field required :rules="requiredRules" filled dense ref="crmAccountNumber" v-model="order.crmAccountNumber" label="Existing Customer Account Number" ></v-text-field>
                                    </div>
                                    <div class="right-field">
                                      <v-text-field required :rules="requiredRules" filled dense ref="companyName" v-model="order.companyName" label="Company Name" ></v-text-field>
                                    </div>
                                    <v-text-field required :rules="requiredRules" filled dense ref="emailAddress" v-model="order.emailAddress" label="Email Address" ></v-text-field>
                                  </div>
                                  <div v-if="order.existingCustomer === false">
                                    <h4 v-bind:class="{'text-muted': order.existingCustomer}">New Customer</h4>
                                    <div class="left-field">
                                      <v-text-field required :rules="requiredRules" filled dense ref="authorisedContactFirstName" v-model="order.authorisedContactFirstName" label="First Name" ></v-text-field>
                                    </div>
                                    <div class="right-field">
                                      <v-text-field required :rules="requiredRules" filled dense ref="authorisedContactLastName" v-model="order.authorisedContactLastName" label="Last Name" ></v-text-field>
                                    </div>
                                    <div class="left-field">
                                      <v-text-field required :rules="requiredRules" filled dense ref="authorisedContactPosition" v-model="order.authorisedContactPosition" label="Position" ></v-text-field>
                                    </div>
                                    <div class="right-field">
                                      <v-text-field required :rules="requiredRules" filled dense ref="emailAddress" v-model="order.emailAddress" label="Email Address" ></v-text-field>
                                    </div>
                                    <hr>
                                    <div class="left-field">
                                      <v-text-field required :rules="requiredRules" filled dense ref="companyNameNew" v-model="order.companyName" label="Company Name" ></v-text-field>
                                    </div>
                                    <div class="right-field">
                                      <v-text-field filled dense ref="accountSite" v-model="order.accountSite" label="Account Site e.g Head Office" ></v-text-field>
                                    </div>
                                    <div class="left-field">
                                      <v-text-field required :rules="requiredRules" filled dense ref="phoneNumber" v-model="order.phoneNumber" label="Phone Number" ></v-text-field>
                                    </div>
                                    <div class="right-field">
                                      <v-text-field filled dense ref="faxNumber" v-model="order.faxNumber" label="Fax Number" ></v-text-field>
                                    </div>
                                    <div class="left-field">
                                      <v-text-field filled dense ref="website" v-model="order.website" label="Website" ></v-text-field>
                                    </div>
                                    <div class="right-field">
                                      <v-text-field filled dense ref="numberOfEmployees" v-model="order.numberOfEmployees" label="Number Of Employees" ></v-text-field>
                                    </div>
                                    <v-text-field filled dense ref="registeredNumber" v-model="order.registeredNumber" label="Registered Number" ></v-text-field>
                                    <h4 style="display:inline-block;">Billing Contact</h4>
                                    <div style="float:right; margin-top:20px;">
                                      <v-btn class="float-right btn btn-ukit-primary" style="margin-top:2px; padding:4px; line-height:5px; height:20px; font-size:10px; color:#fff;" @click="copyAuthDetailsToAccount()" >Same as Above</v-btn>
                                    </div>
                                    <br>
                                    <div class="left-field">
                                      <v-text-field required :rules="requiredRules" filled dense style="margin-top: 15px;"   ref="accountsContactFirstName" v-model="order.accountsContactFirstName" label="First Name"></v-text-field>
                                    </div>
                                    <div class="right-field">
                                      <v-text-field required :rules="requiredRules" filled dense style="margin-top: 15px;"   ref="accountsContactLastName" v-model="order.accountsContactLastName" label="Last Name"></v-text-field>
                                    </div>
                                    <v-text-field required :rules="requiredRules" filled dense ref="accountsContactEmail" v-model="order.accountsContactEmail" label="Email Address" ></v-text-field>
                                    <h4 style="display:inline-block;">Technical Contact</h4>
                                    <div style="float:right; margin-top:20px;">
                                      <v-btn class="float-right btn btn-ukit-primary" style="margin-top:2px; padding:4px; line-height:5px; height:20px; font-size:10px; color:#fff;" @click="copyAuthDetailsToTechnical()" >Same as Above</v-btn>
                                    </div>
                                    <br>
                                    <div class="left-field">
                                      <v-text-field required :rules="requiredRules" filled dense style="margin-top: 15px;" ref="technicalContactFirstName" v-model="order.technicalContactFirstName" label="First Name"></v-text-field>
                                    </div>
                                    <div class="right-field">
                                      <v-text-field required :rules="requiredRules" filled dense style="margin-top: 15px;" ref="technicalContactLastName" v-model="order.technicalContactLastName" label="Last Name"></v-text-field>
                                    </div>
                                    <v-text-field required :rules="requiredRules" filled dense ref="technicalContactEmail" v-model="order.technicalContactEmail" label="Email Address"></v-text-field>
                                  </div>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-form>
                        </div>
                        <div style="margin-top: -30px; margin-right: 12px;" class="float-right">
                          <v-btn class="mr-2 btn btn-ukit-secondary" style="color:#fff;" @click="backToResults()" >Back</v-btn>
                          <v-btn class="float-right btn-ukit-primary" style="color:#fff;" @click="goToInstall()" >Next</v-btn>
                        </div>
                      </v-stepper-content>

                      <v-stepper-content step="2">
                        <v-form ref="installForm" lazy-validation v-model="installFormValid" class="bbc_zeroTop">
                          <v-container  class="bbc_zeroTop">
                            <v-row  class="bbc_zeroTop">
                              <v-col class="bbc_zeroTop" cols="12" md="12">
                                <h4>Install/Site Details</h4>
                                <div class="left-field">
                                  <v-text-field required :rules="requiredRules"  filled dense ref="installContactName" v-model="order.installContactName" label="Contact Name" ></v-text-field>
                                </div>
                                <div class="right-field">
                                  <v-text-field required :rules="requiredRules"  filled dense ref="installContactPhone" v-model="order.installContactPhone" label="Contact Phone" ></v-text-field>
                                </div>
                                <div class="left-field">
                                  <v-text-field required :rules="requiredRules"  filled dense ref="installLocation" v-model="order.installLocation" label="Install Location (Head Office etc)" ></v-text-field>
                                </div>
                                <div class="right-field">
                                  <v-text-field required filled dense ref="installFloor" v-model="order.installFloor" label="Install Floor (Ground Floor / First Floor / Other etc)" ></v-text-field>
                                </div>
                                <div class="left-field">
                                  <v-text-field required filled dense ref="installRoom" v-model="order.installRoom" label="Room (Comms Room / Other)" ></v-text-field>
                                </div>
                                <div class="right-field">
                                  <v-text-field required filled dense ref="installMountingType" v-model="order.installMountingType" label="Mounting Type (Rack Mounted / Wall Mounted / Other)" ></v-text-field>
                                </div>
                                <div class="left-field">
                                  <v-text-field required filled dense ref="installCabinet" v-model="order.installCabinet" label="Cabinet (Cabinet reference or number if applicable)" ></v-text-field>
                                </div>
                                <div class="right-field">
                                  <v-text-field required filled dense ref="installShelf" v-model="order.installShelf" label="Shelf (Shelf location if applicable)" ></v-text-field>
                                </div>
                                <v-text-field required filled dense ref="installAdditionalRequirements" v-model="order.installAdditionalRequirements" label="Additional Requirements" ></v-text-field>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-form>
                        <div style="margin-top: -30px; margin-right: 12px;" class="float-right">
                          <v-btn class="mr-2 btn btn-ukit-secondary" @click="previousStep()" >Back</v-btn>
                          <v-btn class="float-right btn btn-ukit-primary" @click="goToConfirmation()" >Next</v-btn>
                        </div>
                      </v-stepper-content>
                      <v-stepper-content step="3">
                        <v-form ref="confirmForm" lazy-validation v-model="confirmFormValid" class="bbc_zeroTop">
                          <v-container class="bbc_zeroTop">
                            <v-row class="bbc_zeroTop">
                              <v-col class="bbc_zeroTop" cols="12" md="12">
                                <h5>Requested Installation Date</h5>
                                <a-date-picker format="DD/MM/YYYY" :default-value="$moment().add(65, 'days').endOf('day')" :disabled-date="disabledDate" class="mb-2" v-model="order.installationRequiredDate" @change="dateChanged" />
                                <div class="mb-3">
                                  <span class="mr-2">Is this circuit used for voice?</span>
                                  <a-switch checked-children="Yes" un-checked-children="No" @change="voiceChange" default-checked />
                                </div>
                                <h5>Backup Line<small class="text-muted FTTCBackup"> (*FTTC subject to availability)</small></h5>
                                <a-select :options="backupLines" size="large" default-value="Backup Not Required" @change="backupLineChange" v-model="order.backupLineTypeId">
                                  <!-- <a-select-option value="3">Include FTTC Backup Line*</a-select-option>
                                  <a-select-option value="2">Include ADSL 2+</a-select-option>
                                  <a-select-option value="1">Backup Not Required</a-select-option> -->
                                </a-select>
                                <h5 class="mt-2">Routed IP Range</h5>
                                <a-select  size="large" default-value="New Line"   @change="routedIPRangeChange"  v-model="order.routedIPRange">
                                  <a-select-option value="/30">/30</a-select-option>
                                  <a-select-option value="/29">/29</a-select-option>
                                  <a-select-option value="/28">/28</a-select-option>
                                  <a-select-option value="/27">/27</a-select-option>
                                  <a-select-option value="/26">/26</a-select-option>
                                  <a-select-option value="/25">/25</a-select-option>
                                  <a-select-option value="/24">/24</a-select-option>
                                </a-select>
                                <small class="mb-2">Note: The default IP Range has been changed to /30 to conserve IP’s. If a /29 range is required please provide the justification within internet requirements. If alternative range required please complete a RIPE form which can be requested from your account manager.</small>
                                <v-textarea filled v-model="order.internetRequirements" label="Internet requirements"></v-textarea>
                                <h4 class="mt-2">Router Delivery</h4>
                                <div class="left-field">
                                  <v-text-field required :rules="requiredRules" filled dense ref="routerDeliveryContactFirstName" v-model="order.routerDeliveryContactFirstName" label="Delivery Contact First Name" ></v-text-field>
                                </div>
                                <div class="right-field">
                                  <v-text-field required :rules="requiredRules" filled dense ref="routerDeliveryContactLastName" v-model="order.routerDeliveryContactLastName" label="Delivery Contact Last Name" ></v-text-field>
                                </div>
                                <v-text-field required :rules="requiredRules" filled dense ref="routerDeliveryContactPhone" v-model="order.routerDeliveryContactPhone" label="Delivery Contact Phone" ></v-text-field>
                                <div class="left-field">
                                  <v-text-field required :rules="requiredRules" filled dense ref="routerDeliveryContactAddressStreet" v-model="order.routerDeliveryContactAddressStreet" label="Delivery Address - Street" ></v-text-field>
                                </div>
                                <div class="right-field">
                                  <v-text-field required :rules="requiredRules" filled dense ref="routerDeliveryContactAddressTown" v-model="order.routerDeliveryContactAddressTown" label="Delivery Address - Town" ></v-text-field>
                                </div>
                                <div class="left-field">
                                  <v-text-field required :rules="requiredRules" filled dense ref="routerDeliveryContactAddressCounty" v-model="order.routerDeliveryContactAddressCounty" label="Delivery Address - County" ></v-text-field>
                                </div>
                                <div class="right-field">
                                  <v-text-field required :rules="requiredRules" filled dense ref="routerDeliveryContactAddressPostcode" v-model="order.routerDeliveryContactAddressPostcode" label="Delivery Address - Postcode" ></v-text-field>
                                </div>
                                <v-text-field required :rules="requiredRules" filled dense ref="routerDeliveryContactAddressCountry" v-model="order.routerDeliveryContactAddressCountry" label="Delivery Address - Country" val="United Kingdom"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-form>
                        <div style="margin-top: -30px; margin-right: 12px;" class="float-right">
                          <v-btn class="mr-2 btn btn-ukit-secondary" @click="previousStep()" >Back</v-btn>
                          <v-btn class="float-right btn btn-ukit-primary" @click="goToAgreement()" >Next</v-btn>
                        </div>
                      </v-stepper-content>
                      <v-stepper-content step="4">
                        <div class="row justify-content-md-center">
                          <div class="col-md-4">
                             <vue-recaptcha @verify="verifyCaptcha" :loadRecaptchaScript="true" sitekey="6LdiF-IZAAAAADEsRPYbWcIGf3FssZBcFcKT3pKk"></vue-recaptcha>
                           </div>
                        </div >
                        <div v-if="clientSettings.tsAndCsRequired">
                          <p class="text-center">By clicking Agree To Terms, I agree to the terms and conditions (UK IT Networks Limited Terms & Conditions v2.2) set out on your website <a href="https://ukitnetworks.com/terms-and-conditions" target="_blank">ukitnetworks.com/terms-and-conditions</a>, confirm that the information on this broadband order is correct, and I am authorised to sign for and behalf of {{ order.companyName }}. Until we notify you to the contrary, you may contact us by letter, telephone, fax, e-mail, sms or any other electronic means with regards to products and services offered by UK IT Networks Limited.</p>
                          <div class="row">
                            <div class=" col-md-12">
                              <div @scroll="handleScroll" class="tsAndCsContainer">
                                <div style="position: absolute;top: -10px;right: 15px;z-index: 6000;">
                                  <span class="text-ukit-primary">Scroll Down To Agree to Ts and Cs</span> <i class="fa fa-arrow-down"></i>
                                </div>
                                <termsandconditions></termsandconditions>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12 text-center">
                            <button v-if="!hasScrolledToBottom || vid === null" disabled="disabled" class="disabled btn ">Agree To Terms</button>
                            <button v-on:click="completeOrder()" v-if="hasScrolledToBottom && vid != null" class="btn btn-green">Agree To Terms</button>
                          </div>
                        </div>
                        <div v-if="!clientSettings.tsAndCsRequired">
                          <p class="text-center">I agree to the above order and all information provided is the responsibility of the applicant. I accept all charges, lead times and contractual periods as per the Chess Partner Service pricing provided.<p>
                          <div class="col-md-12 text-center">
                            <button v-on:click="completeOrder()" v-if="vid != null" class="btn btn-green">Complete Order</button>
                          </div>
                        </div>
                      </v-stepper-content>
                    </v-stepper-items>
                  </v-stepper>
                </div>

                <div class="col-md-4 pr-4">
                  <div class="card p-2" style="margin-top:16px;">
                    <h4 class="text-ukit-primary text-center">Your Order</h4>
                    <table class="table table-striped">
                      <tbody>
                        <tr>
                          <td colspan="2" class="text-center">
                            <strong>{{ order.selectedResult.productName }}</strong>
                          </td>
                        </tr>
                        <tr v-if="order.selectedResult.showSpeed">
                          <td>Speed</td>
                          <td>
                            <span v-if="order.selectedResult.productName.includes('EFM')">{{ order.selectedResult.linecdr }}</span>
                            <span v-else>{{ order.selectedResult.linecdr }}/{{ order.selectedResult.bearer }}</span>
                          </td>
                        </tr>
                        <tr>
                          <td>Contract Term</td>
                          <td>{{ order.selectedResult.contractTermMonths }} Months</td>
                        </tr>
                        <tr>
                          <td>Backup Cost</td>
                          <td>£{{ order.selectedResult.backupMonthlyCost }}/Month</td>
                        </tr>
                        <tr>
                          <td>Backup Type</td>
                          <td>{{ order.selectedResult.backupType }}</td>
                        </tr>
                        <tr>
                          <td>Install Charge</td>
                          <td>
                            <span v-if="order.selectedResult.installationCharge !== 0">£{{ toTwoDecimalPlaces(order.selectedResult.installationCharge) }}</span>
                            <span v-if="order.selectedResult.installationCharge === 0" class="text-ukit-primary">INCLUDED</span>
                          </td>
                        </tr>
                        <tr>
                          <td>Total Monthly Cost</td>
                          <td>£{{ toTwoDecimalPlaces(order.totalMonthlyCost) }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <button v-on:click="backToResults()" class="btn btn-ukit-secondary btn-block ">Back to Results</button>
                  </div>

                  <div class="card p-2">
                    <h4 class="text-ukit-secondary text-center">What's Included?</h4>
                    <table class="table table-striped">
                      <tbody>
                        <tr>
                          <td>Dedicated UK Account Manager</td>
                          <td class="text-ukit-primary"><i class="fa fa-check"></i></td>
                        </tr>
                        <tr>
                          <td>Online Billing Platform Access</td>
                          <td class="text-ukit-primary"><i class="fa fa-check"></i></td>
                        </tr>
                        <tr>
                          <td>UK Based Support Desk</td>
                          <td class="text-ukit-primary"><i class="fa fa-check"></i></td>
                        </tr>
                        <tr>
                          <td>End Of Contract Notifications</td>
                          <td class="text-ukit-primary"><i class="fa fa-check"></i></td>
                        </tr>
                        <tr>
                          <td>Cisco Managed Router <small>(optional)</small></td>
                          <td class="text-ukit-primary"><i class="fa fa-check"></i></td>
                        </tr>
                        <tr>
                          <td>Routed IP Range Options</td>
                          <td class="text-ukit-primary"><i class="fa fa-check"></i></td>
                        </tr>
                        <tr>
                          <td>HSRP Mirrored IP Failover <small>(optional)</small></td>
                          <td class="text-ukit-primary"><i class="fa fa-check"></i></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </zoom-center-transition>

          <div class="bbc_promoContainer">
            <zoom-center-transition>
              <div v-if="quoteResult && stage === 'results'" class="results" style="width:100%; height:100%; padding:15px;">
                <div v-if="!quoteResult.results.length" class="col-md-12 resHeader" >
                  <div class="text-center">Please wait whilst we fetch your quotes</div>
                </div>

                <div v-if="quoteResult.results.length" class="float-right">
                  <div class="form-check float-left mr-2">
                    <input v-model="quoteFilter.include60months" type="checkbox" class="form-check-input" id="filter60months" @change="filterResults()">
                    <label class="form-check-label" style="font-size:12px;">60 Month Terms</label>
                  </div>
                  <div class="form-check float-left mr-2">
                    <input v-model="quoteFilter.include36months" type="checkbox" class="form-check-input" id="filter36months" @change="filterResults()">
                    <label class="form-check-label" style="font-size:12px;">36 Month Terms</label>
                  </div>
                  <div class="form-check float-left">
                    <input v-model="quoteFilter.include12months" type="checkbox" class="form-check-input" id="filter12months" @change="filterResults()">
                    <label class="form-check-label" style="font-size:12px;">12 Month Terms</label>
                  </div>
                </div>
                <h3 v-if="quoteResult.results.length" class="text-ukit-secondary" style="text-align:left; padding-bottom:16px;">
                  Leased Line Results
                  <a href="/ethernet" class="btn btn-xs btn-ukit-secondary ml-3">Start Again</a>
                  <button v-on:click="toggleSpeedTest()" class="btn btn-xs btn-ukit-primary ml-3">Test Your Current Connection</button>
                  <button v-on:click="toggleQuickResults()" class="btn btn-xs btn-ukit-secondary ml-3">Email Me Results</button>
                </h3>
                <div v-if="quoteResult.results.length" class="row">
                  <table class="table table-striped table-hover">
                    <thead>
                      <tr>
                        <th>Supplier</th>
                        <th>Product</th>
                        <th class="text-center">Term</th>
                        <th>Speed</th>
                        <th v-if="quoteResult.clientSettings.showInstallation">Install Charge</th>
                        <th v-if="quoteResult.clientSettings.showMonthly">Monthly</th>
                        <th class="text-center">Lead Time</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(result, index) in quoteResult.results" v-bind:key="result.id">
                        <td v-if="!result.filtered">
                          <img v-if="result.supplier == 'BT Wholesale' || result.supplier == 'BTW'" src="resources/images/logos/bt-wholesale_x100.png" alt="BT Wholesale">
                          <img v-else-if="result.supplier == 'TalkTalk Business' || result.supplier == 'TTB'" src="resources/images/logos/talktalk-business_x63.png" alt="Talk Talk Business">
                          <img v-else-if="result.supplier == 'SSE'" src="resources/images/logos/sse_x60.png" alt="SSE">
                          <img v-else-if="result.supplier == 'Vodafone'" src="resources/images/logos/vodafone_x100.png" alt="Vodafone">
                          <img v-else-if="result.supplier == 'Virgin Media'" src="resources/images/logos/virgin-media.png_x64" alt="Virgin Media">
                          <span v-else>{{ result.supplier }}</span>
                        </td>
                        <td v-if="!result.filtered" class="productTblName text-ukit-secondary">
                          <span v-if="index === 0">
                            <div class="float-left mr-2 text-ukit-secondary">
                              {{ result.productName }}
                            </div>
                            <div class="bg-ukit-primary" style="border-radius:4px; float:right; padding:0px 10px 0px 10px;">
                              <a-popover>
                                <template slot="content">
                                  <div><i class="fa fa-info-circle" style="margin-right:5px;"></i>Lowest Cost For Quickest Speed</div>
                                </template>
                                <span class="text-white" style="font-weight: 600;">Best Value</span>
                              </a-popover>
                            </div>
                          </span>
                          <span v-else-if="result.isCheapestThreeYear">
                            <div class="float-left mr-2 text-ukit-secondary">
                              {{ result.productName }}
                            </div>
                            <div class="bg-ukit-secondary" style="border-radius:4px; float:right; padding:0px 10px 0px 10px;">
                              <a-popover>
                                <template slot="content">
                                  <div><i class="fa fa-info-circle" style="margin-right:5px;"></i>Most Selected Leased Line</div>
                                </template>
                                <span class="text-white" style="font-weight: 600;">Favourite</span>
                              </a-popover>
                            </div>
                          </span>
                          <span v-else>{{ result.productName }}</span>
                        </td>
                        <td v-if="!result.filtered" class="text-center">
                          <strong class="mbl">Term: </strong>
                          <span>{{ result.contractTermMonths }} Months</span>
                        </td>
                        <td v-if="!result.filtered">
                          <strong class="mbl">Speed: </strong>
                          <span v-if="result.productName.includes('EFM')"></span>
                          <span v-else>{{ result.linecdr }}/{{ result.bearer }}</span>
                        </td>
                        <td v-if="!result.filtered && quoteResult.clientSettings.showInstallation">
                          <strong class="mbl">Install Cost: </strong>
                          <span v-if="result.installationCharge === 0" class="text-ukit-primary">FREE</span>
                          <span v-else>£{{ toTwoDecimalPlaces(result.installationCharge) }}</span>
                        </td>
                        <td v-if="!result.filtered && quoteResult.clientSettings.showMonthly">
                          <strong class="mbl">Monthly: </strong>
                          <span>£{{ toTwoDecimalPlaces(result.recurringCharge) }}</span>
                        </td>
                        <td v-if="!result.filtered" class="text-center">
                          <strong class="mbl"></strong>
                          <span>65 Working Days</span>
                        </td>
                        <td v-if="!result.filtered" class="text-center">
                          <button v-on:click="selectResult(result)" class="btn btn-ukit-primary btn-sm btn-block">Select</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div v-if="!quoteResult.isComplete" class="col-md-12 resultRow" id="stillLoading" style="padding:0;">
                  <div class="resHeader text-center">
                    <div class="wrap">
                      <div class="track">
                        <div class="pacman"></div>
                        <div class="dots">
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                      </div>
                    </div>
                    <!-- <p class="saving"><span>Checking with all network partners</span><span>.</span><span>.</span><span>.</span><span>.</span><span>.</span></p> -->
                    <div style="width: 100%; background-color: rgba(249, 249, 249, 0.2);padding: 5px; margin-bottom: 15px; margin-top: -10px;">
                      <i class="fa fa-info-circle" style="padding-right:6px;"></i><strong>It may take up to 90 seconds to return all pricing results</strong>
                    </div>
                  </div>
                </div>

                <div v-if="quoteResult.isComplete" class="col-md-12 resultRow " id="finishedLoading">
                  <div class="resHeader text-center pt-4 pb-2  ">
                    <p class="saving"><strong>Checks complete</strong></p>
                  </div>
                </div>
                <div class="col-md-12 text-center">
                  <div class="pt-0  ">
                    <a target="_blank" href="http://www.ravenware.co.uk"><img src="resources/poweredByRavenware.png" alt="Powered by Ravenware ltd"></a>
                  </div>
                </div>
              </div>
            </zoom-center-transition>
          </div>
        </div>

        <div id="carousel-wrap">
          <carousel :items="7" :margin="100" :loop="true" :nav="false" :autoplay="true" :autoplaySpeed="3000">
            <img src="resources/images/logos/bt-wholesale.png">
            <img src="resources/images/logos/virgin-media.png">
            <img src="resources/images/logos/cisco.png">
            <img src="resources/images/logos/cityfibre.png">
            <img src="resources/images/logos/openreach.png">
            <img src="resources/images/logos/talktalk-business.png">
            <img src="resources/images/logos/colt.png">
            <img src="resources/images/logos/vodafone.png">
            <img src="resources/images/logos/virtual1.png">
            <img src="resources/images/logos/sse.png">
          </carousel>
        </div>

        <div class="deals-wrap">
          <div class="row">
            <div class="col-4">
              <div class="deal">
                <div class="deal-top">
                  <h6>Lowest Cost</h6>
                  <p class="deal-product">100Mb Managed Ethernet</p>
                  <p class="deal-price">From <strong>£199.00</strong> per month</p>
                  <a href="#greenFrame" class="btn btn-white">Check availability</a>
                </div>
                <div class="deal-bottom">
                  <p><i class="fa fa-check"></i> Free Installation*</p>
                  <p><i class="fa fa-check"></i> 6 Hour Fix Time SLA</p>
                  <p><i class="fa fa-check"></i> 12, 36 or 60 Month Contract</p>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="deal focus">
                <div class="deal-top">
                  <h6>Most Popular</h6>
                  <p class="deal-product">500Mb Managed Ethernet</p>
                  <p class="deal-price">From <strong>£299.00</strong> per month</p>
                  <a href="#greenFrame" class="btn btn-white">Check availability</a>
                </div>
                <div class="deal-bottom">
                  <p><i class="fa fa-check"></i> Free Installation*</p>
                  <p><i class="fa fa-check"></i> 6 Hour Fix Time SLA</p>
                  <p><i class="fa fa-check"></i> 12, 36 or 60 Month Contract</p>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="deal">
                <div class="deal-top">
                  <h6>Best Value</h6>
                  <p class="deal-product">1Gb Managed Ethernet</p>
                  <p class="deal-price">From <strong>£399.00</strong> per month</p>
                  <a href="#greenFrame" class="btn btn-white">Check availability</a>
                </div>
                <div class="deal-bottom">
                  <p><i class="fa fa-check"></i> Free Installation*</p>
                  <p><i class="fa fa-check"></i> 6 Hour Fix Time SLA</p>
                  <p><i class="fa fa-check"></i> 12, 36 or 60 Month Contract</p>
                </div>
              </div>
            </div>
            <small>*subject to a 36 month contract</small>
          </div>
        </div>

        <div class="faqs-wrap">
          <div class="row">
            <div class="col-3 faq-questions">
              <h4>Frequently Asked Questions</h4>
              <div class="questions">
                <div v-for="(faq,index) in faqs" v-bind:key="index" class="faq-question" v-on:click="selectFaq(index)">
                  <h6 v-if="selectedFaq == index" class="selected"><i class="fa fa-question-circle"></i> {{ faq.question }}</h6>
                  <h6 v-else><i class="fa fa-question-circle"></i> {{ faq.question }}</h6>
                </div>
              </div>
            </div>
            <div class="col-9 faq-answers">
              <div class="answers">
                <div v-for="(faq,index) in faqs" v-bind:key="index" class="faq-answer">
                  <div v-if="selectedFaq == index" class="answer-wrap">
                    <div class="answer">
                      <h5>{{ faq.question }}</h5>
                      <p>{{ faq.answer }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <a href="/support" class="btn btn-ukit-secondary">Contact Us</a>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div id="footer-top">
      <h6>Need some assistance? We can help.</h6>
      <v-btn href="/about-us">Find out more</v-btn>
    </div>

    <div id="footer-bottom">
      <div class="row">
        <div class="col-md-3">
          <img class="footer-logo" src="resources/images/logos/uk_business_broadband_x300.png" alt="UK Business Broadband Logo">
        </div>
        <div class="col-md-9">
          <ul class="footer-menu">
            <li><a href="https://ukitnetworks.com/privacy-policy/" target="_blank" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2479">Privacy Policy v1.0</a></li>
            <li><a href="/support" class="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-2542current_page_item menu-item-2699">Customer Support</a></li>
            <li><a href="https://ukitnetworks.com/terms-and-conditions/" target="_blank" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2478">Terms and Conditions</a></li>
          </ul>
          <div class="legal-details">
            <p>Registered in England and Wales: 8026657</p>
            <p>Ofcom Reseller ID: FLV</p>
            <p>ICO Reg Number: A422750</p>
            <p>VAT Reg Number: 121 9534 29</p>
          </div>
        </div>
        <div class="col-md-12">
          <div class="social-icons">
            <a href="https://www.linkedin.com/company/uk-it-networks-limited"><i class="fa fa-linkedin-square"></i></a>
            <a href="https://twitter.com/ukitnetworks?lang=en"><i class="fa fa-twitter-square"></i></a>
            <a href="https://www.facebook.com/UKITNET/"><i class="fa fa-facebook-square"></i></a>
          </div>
          <div class="contact-icons">
            <a href="tel:03443262154"><i class="fa fa-phone-square"></i></a>
            <a href="mailto:info@ukbusinessbroadband.com" target="_blank"><i class="fa fa-envelope-square"></i></a>
          </div>
        </div>
      </div>
    </div>

    <a-modal :width="650" :footer="null" v-model="showSpeedTest" title="Broadband Speed Test" ok-text="OK" @ok="showSpeedTest=false">
      <iframe frameBorder="0" src="https://openspeedtest.com/Get-widget.php" width="600" height="350" style="display:block; margin:auto;"></iframe>
      <br>
      <br>
      <div style="margin-top:-20px;" class="float-right">
        <button class="btn btn-sm btn-ukit-primary" v-on:click="toggleSpeedTest()">CLOSE</button>
      </div>
    </a-modal>

    <a-modal :width="650" :footer="null" v-model="showQuickResults" title="Email Me Results" ok-text="OK" @ok="showQuickResults=false">
      <div id="quick-quote">
        <v-text-field v-if="!quickQuoteSent" v-model="order.quickQuoteEmailAddress" ref="quickQuoteEmailAddress" label="Email Address" ></v-text-field>
        <button v-if="!quickQuoteSent && order.quickQuoteEmailAddress === ''" class="btn btn-ukit-secondary btn-sm" disabled>Send Results</button>
        <button v-if="!quickQuoteSent && order.quickQuoteEmailAddress !== ''" v-on:click="emailQuoteResults()" class="btn btn-ukit-secondary btn-sm">Send Results</button>
        <h4 v-if="quickQuoteSent">Thank you, your quote results have been emailed to you</h4>
      </div>
      <br>
      <br>
      <div style="margin-top:-20px;" class="float-right">
        <button class="btn btn-sm btn-ukit-primary" v-on:click="toggleQuickResults()">CLOSE</button>
      </div>
    </a-modal>

  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import _ from 'lodash'
import { ZoomCenterTransition } from 'vue2-transitions'
import termsandconditions from '@/components/tenant/ukittermsandconditions'
import carousel from 'vue-owl-carousel'

export default {
  name: 'Home',
  components: {
    Loading,
    ZoomCenterTransition,
    termsandconditions,
    carousel,
    VueRecaptcha,
  },

  computed: {
    filteredQuotes: function() {
      let retARR = this.quotes.filter(q => this.displayQuote(q))
        .sort((b, a) => a.productSpeed.minimumGuaranteedSpeed - b.productSpeed.minimumGuaranteedSpeed)
      return retARR
    },

    userStyle() {
      return {
        '--dynRes-secondaryColor': this.clientSettings.secondaryColor,
        '--dynRes-primaryColor': this.clientSettings.primaryColor,
        '--resHeader-tableHeaderColor': this.clientSettings.tableHeaderColor,
        '--resHeader-tableHeaderTextColor': this.clientSettings.tableHeaderTextColor,
        '--resultRow-tableTextColor': this.clientSettings.tableTextColor,
        '--resultRowTop-tableBestQuoteColor': this.clientSettings.tableBestQuoteColor,
        '--resultRowTop-tableBestQuoteTextColor': this.clientSettings.tableBestQuoteTextColor,
        '--bgPage': this.clientSettings.backgroundColour,
      }
    },
  },

  mounted() {
    this.mounted = true
    this.iframeHeightChangeNotifyParent()
  },

  updated: function() {
    this.$nextTick(function() {
      this.iframeHeightChangeNotifyParent()
    })
  },

  beforeCreate() {
    this.addressSearchForm = this.$form.createForm(this, { name: 'addressSearch' })
  },

  created() {
    window.addEventListener('resize', this.windowResized)

    this.orderForm = this.$form.createForm(this, { name: 'orderForm' })
    if (this.$route.query.id) {
      this.quoteId = this.$route.query.id
      this.getResults()
    } else {
      this.quoteId = null
    }

    this.params.tid = '2807F490-5E8A-46BE-9718-0172CCB13B4F'
  },

  watch: {
  },

  methods: {
    identifyCheapest36Month() {
      if (this.quoteResult != null && this.quoteResult.results.length) {
        let result = this.quoteResult.results.find(res => (res.contractTermMonths === 36 || res.contractTermMonths === '36'))
        this.quoteResult.results.forEach(element => {
          element.isCheapestThreeYear = false
        })
        result.isCheapestThreeYear = true
      }
    },

    disabledDate(current) {
      // Can not select days before today and today
      return current && current < this.$moment().add(65, 'days').endOf('day')
    },

    verifyCaptcha(e) {
      this.vid = e
    },

    voiceChange(e) {
      if (e) {
        this.order.voiceIncluded = 'Yes'
      } else {
        this.order.voiceIncluded = 'No'
      }
    },

    calcTotals() {
      this.order.totalMonthlyCost = parseFloat(this.toTwoDecimalPlaces(this.order.selectedResult.backupMonthlyCost)) + parseFloat(this.toTwoDecimalPlaces(this.order.selectedResult.recurringCharge))
    },

    sendEnquiry(e) {
      if (this.$refs.enquiryForm.validate()) {
        this.order.vid = this.vid
        this.toggleLoading()
        this.$http.post('/api/ukbroadband/raiseEthernetEnquiry/', this.order)
          .then(response => {
            this.toggleLoading()
            this.stage = 'thankyouEnquiry'
            this.$nextTick(function() {
              this.iframeHeightChangeNotifyParent()
              this.scrollToTop()
            })
          }
          )
          .catch(e => {
            this.toggleLoading()
            this.$message.error('There has been an error please try again or contact support.')
          })
      }
    },

    backToResults() {
      this.stage = 'results'
      this.$nextTick(function() {
        this.iframeHeightChangeNotifyParent()
        this.scrollToTop()
      })
    },

    filterResults() {
      this.quoteResult.results.forEach(element => {
        if (
          (this.quoteFilter.include60months && (element.contractTermMonths === 60 || element.contractTermMonths === '60')) ||
          (this.quoteFilter.include36months && (element.contractTermMonths === 36 || element.contractTermMonths === '36')) ||
          (this.quoteFilter.include12months && (element.contractTermMonths === 12 || element.contractTermMonths === '12'))
        ) {
          element.filtered = false
        } else {
          element.filtered = true
        }
      })
    },

    toggleSpeedTest() {
      if (this.showSpeedTest) {
        this.showSpeedTest = false
      } else {
        this.showSpeedTest = true
      }
    },

    toggleQuickResults() {
      if (this.showQuickResults) {
        this.showQuickResults = false
      } else {
        this.showQuickResults = true
      }
    },

    emailQuoteResults() {
      let ethernetQuotes = {
        products: this.quoteResult.results,
        tid: this.params.tid,
        emailAddress: this.order.quickQuoteEmailAddress,
        quoteRequestId: this.quoteId,
      }

      this.$http.post('/api/ukbroadband/emailCustomerEthernetQuotes/', ethernetQuotes)
        .then(response => {
          this.iframeHeightChangeNotifyParent()
          this.quickQuoteSent = true
        })
        .catch(e => {
          this.errors.push(e)
          alert('Error')
        })
    },

    handleScroll: function(el) {
      if ((el.srcElement.offsetHeight + el.srcElement.scrollTop) >= el.srcElement.scrollHeight) {
        this.hasScrolledToBottom = true
      }
    },

    dateChanged() {},

    routedIPRangeChange() {},

    copyAuthDetailsToAccount() {
      this.order.accountsContactName = this.order.authorisedContactName
      this.order.accountsContactFirstName = this.order.authorisedContactFirstName
      this.order.accountsContactLastName = this.order.authorisedContactLastName
      this.order.accountsContactEmail = this.order.emailAddress
    },

    copyAuthDetailsToTechnical() {
      this.order.technicalContactName = this.order.authorisedContactName
      this.order.technicalContactFirstName = this.order.authorisedContactFirstName
      this.order.technicalContactLastName = this.order.authorisedContactLastName
      this.order.technicalContactEmail = this.order.emailAddress
    },

    toggleExistingCustomer() {
      if (this.order.existingCustomer) {
        this.order.existingCustomer = false
        this.order.companyType = 'New Customer'
      } else {
        this.order.existingCustomer = true
        this.order.companyType = 'Existing Customer'
      }
      this.$nextTick(function() {
        this.iframeHeightChangeNotifyParent()
      })
    },

    backupLineChange(e) {
      this.order.backupLineTypeId = e
      if (e === 3) {
        this.order.selectedResult.backupType = 'Include FTTC Backup Line*'
        this.order.selectedResult.backupMonthlyCost = '70.50'
      }
      if (e === 2) {
        this.order.selectedResult.backupType = 'Include ADSL 2+'
        this.order.selectedResult.backupMonthlyCost = '56.35'
      }
      if (e === 1) {
        this.order.selectedResult.backupType = 'Backup Not Required'
        this.order.selectedResult.backupMonthlyCost = '0.00'
      }
      this.calcTotals()
    },

    completeOrder() {
      this.toggleLoading()
      this.order.vid = this.vid
      this.$http.post('/api/ukbroadband/raiseEthernetOrder/', this.order)
        .then(response => {
          this.toggleLoading()
          this.stage = 'thankyou'
          this.$nextTick(function() {
            this.iframeHeightChangeNotifyParent()
            this.scrollToTop()
          })
        }
        )
        .catch(e => {
          this.toggleLoading()
          this.$message.error('There has been an error please try again or contact support.')
        })
    },

    unSelectResult(result) {
      this.order = null
      result.selected = false
      this.$nextTick(function() {
        this.iframeHeightChangeNotifyParent()
        this.scrollToTop()
      })
    },

    selectEnquiry() {
      this.order.orderType = 'Enquiry'
      this.stage = 'enquiry'
      this.$nextTick(function() {
        this.iframeHeightChangeNotifyParent()
        this.scrollToTop()
      })
    },

    selectOrder() {
      this.order.orderType = 'Order'
      this.stage = 'wizard'
      this.$nextTick(function() {
        this.iframeHeightChangeNotifyParent()
        this.scrollToTop()
      })
    },

    selectResult(result) {
      this.toggleLoading()
      this.$http.get('/api/ethernet/GetOrder/' + result.id)
        .then(response => {
          this.order = response.data
          this.order.selectedResult = result
          this.order.routedIPRange = '/30'
          this.backupLineChange(1)
          var date = new Date()
          date.setDate(date.getDate() + 65)
          this.order.installationRequiredDate = date
          this.stage = 'enquireOrOrder'
          this.order.voiceIncluded = 'Yes'
          this.order.installationRequiredDate = this.$moment().add(65, 'days').endOf('day')
          this.toggleLoading()
          this.$nextTick(function() {
            this.iframeHeightChangeNotifyParent()
            this.scrollToTop()
          })
          this.calcTotals()
        })
        .catch(e => {
          this.toggleLoading()
          this.$message.error('There has been an error returning the enqury form please try again.')
        })
      this.quoteResult.results.forEach(element => {
        element.selected = false
        element.filtered = false
      })
      result.selected = true
    },

    toggleLoading() {
      if (this.isLoading === true) {
        this.isLoading = false
      } else {
        this.isLoading = true
      }
    },

    toTwoDecimalPlaces: function(value) {
      if (value === null) {
        return 0.00
      } else {
        return parseFloat(value).toFixed(2)
      }
    },

    windowResized: _.debounce(function(e) {
      let width = document.getElementById('ravenwareSite').scrollWidth
      if (width !== this.windowSize.width) {
        this.windowSize.width = document.getElementById('ravenwareSite').scrollWidth
        this.iframeHeightChangeNotifyParent()
      }
    }, 1),

    iframeHeightChangeNotifyParent: _.debounce(function(e) {
      let height
      let el = document.getElementById('ravenwareSite')
      if (el != null) {
        height = document.getElementById('ravenwareSite').scrollHeight
      } else {
        height = 200
      }
      window.parent.postMessage({ frameHeight: height }, '*')
    }, 1),

    iframeHeightSpecificSizeNotifyParent(height) {
      window.parent.postMessage({ frameHeight: height }, '*')
    },

    scrollToTop() {
      var el = this.$el.getElementsByClassName('scrolltop')[0]

      if (el) {
        el.scrollIntoView()
      }
    },

    getMoreResults() {
      var mythis = this
      setTimeout(function() { mythis.getResults() }, 10000)
    },

    getResults() {
      // this.toggleLoading()
      this.$http.get('/api/ethernet/quoteResults/' + this.quoteId)
        .then(response => {
          if (response.data.requestSuccess) {
            // found the quote.
            this.quoteResult = response.data
            this.clientSettings = response.data.clientSettings
            this.identifyCheapest36Month()
            if (response.data.isComplete === false) {
              // set a timer going to try get more results.
              this.getMoreResults()
            } else {
              this.$nextTick(function() {
                this.iframeHeightChangeNotifyParent()
                this.scrollToTop()
              })
            }
          } else { // not found.
            this.quoteResult = null
            alert('cannot find quote')
          }
          // loader.hide()
          this.quotes = response.data.products
          this.iframeHeightChangeNotifyParent()
          // this.toggleLoading()
        })
        .catch(e => {
          // revert and allow another try.
          this.stage = 'addressSearch'
          this.toggleLoading()
          this.$message.error('There has been an error returning quotes. Please try again')
        })
    },

    formatHyphenatedToMbps(value) {
      let arr = value.split(' - ')
      if (arr[0] <= 0) { arr[0] = 0 }
      if (arr[1] <= 0) { arr[0] = 0 }
      let ret = (arr[1] / 1000).toFixed(2) + 'Mbps - ' + (arr[0] / 1000).toFixed(2) + 'Mbps'
      return ret
    },

    formatHyphenatedMinToMbps(value) {
      let arr = value.split(' - ')
      if (arr[0] <= 0) { arr[0] = 0 }
      if (arr[1] <= 0) { arr[0] = 0 }
      let ret = (arr[0] / 1000).toFixed(2) + 'Mbps'
      return ret
    },

    formatHyphenatedMaxToMbps(value) {
      let arr = value.split(' - ')
      if (arr[0] <= 0) { arr[0] = 0 }
      if (arr[1] <= 0) { arr[0] = 0 }
      let ret = (arr[1] / 1000).toFixed(2) + 'Mbps'
      return ret
    },

    formatToMbps (value) {
      if (value <= 0) { value = 0 }
      return (value / 1000).toFixed(2) + 'Mbps'
    },

    nextStep() {
      this.currentStep += 1
      this.scrollToTop()
    },

    goToAgreement() {
      if (this.$refs.installForm.validate()) {
        this.currentStep = 4
        this.scrollToTop()
      }
    },

    goToConfirmation() {
      if (this.$refs.installForm.validate()) {
        this.currentStep = 3
        this.scrollToTop()
      }
    },

    goToInstall() {
      if (this.$refs.detailsForm.validate()) {
        this.currentStep = 2
        this.scrollToTop()
      }
    },

    previousStep() {
      this.currentStep -= 1
      this.scrollToTop()
    },

    selectFaq(index) {
      this.selectedFaq = index
    },
  },

  data: () => ({
    params: { source: null, tid: null },
    displayLoadingText: false,
    vid: null,
    backupLines: [{ key: 3, label: 'Include FTTC Backup Line*' },
      { key: 2, label: 'Include ADSL 2+' },
      { key: 1, label: 'Backup Not Required' }],
    hasScrolledToBottom: false,
    routedIPRanges: ['/29', '/30', '/28', '/27', '/26', '/25', '/24'],
    requiredShort: [
      v => !!v || 'required',
    ],
    requiredRules: [
      v => !!v || 'This field is required',
    ],
    stage: 'results',
    currentStep: 1,
    orderForm: true,
    installFormValid: true,
    detailsFormValid: true,
    confirmFormValid: true,
    agreementFormValid: true,
    order: {
      backupLine: '',
      backupLineTypeId: 1,
      selectedResult: null,
      routedIPRange: '/30',
      companyType: 'New Customer',
      totalOneOffCost: 0.00,
      totalMonthlyCost: 0.00,
      crmAccountNumber: null,
      sortcode: null,
      customerNumber: null,
      existingCustomer: false,
      selectedQuote: null,
      billingAddressSameAsInstall: true,
      companyName: null,
      emailAddress: null,
      accountSite: null,
      phoneNumber: null,
      faxNumber: null,
      website: null,
      numberOfEmployees: null,
      registeredNumber: null,
      billingMethod: null,
      authorisedContactName: null,
      authorisedContactFirstName: null,
      authorisedContactLastName: null,
      authorisedContactEmail: null,
      authorisationAccess: null,
      accountsContactName: null,
      accountsContactFirstName: null,
      accountsContactLastName: null,
      accountsContactEmail: null,
      accountsContactTelephone: null,
      customerRequiredDate: null,
      installContactName: null,
      installContactPhone: null,
      installLocation: null,
      installFloor: null,
      installRoom: null,
      installMountingType: null,
      installCabinet: null,
      installShelf: null,
      installAdditionalRequirements: null,
      internetRequirements: null,
      routerDeliveryContactName: null,
      routerDeliveryContactFirstName: null,
      routerDeliveryContactLastName: null,
      routerDeliveryContactAddressStreet: null,
      routerDeliveryContactAddressTown: null,
      routerDeliveryContactAddressCounty: null,
      routerDeliveryContactAddressCountry: null,
      routerDeliveryContactAddressPostcode: null,
      routerDeliveryContactPhone: null,
      technicalContactName: null,
      technicalContactFirstName: null,
      technicalContactLastName: null,
      technicalContactPhone: null,
      technicalContactEmail: null,
      voiceIncluded: null,
      quickQuoteEmailAddress: null,
    },
    quoteId: null,
    clientSettings: {},
    quoteResult: null,
    windowSize: { width: 0 },
    isLoading: false,
    loadski: true,
    mounted: false,
    showLoading: true,
    isValid: false,
    showSpeedTest: false,
    showQuickResults: false,
    quoteFilter: { include60months: true, include36months: true, include12months: true },
    faqs: [
      { question: 'Which Networks do you partner with for Ethernet Leased Lines?', answer: 'We have multiple partnering agreements for our Ethernet Leased Line agreements. Utilising a close relationship with BT, Vodafone, TTB and Virgin we can ensure that we can obtain the most competitive pricing for your Ethernet Leased Line quotation.' },
      { question: 'What support can I expect from having an Internet Leased Line?', answer: 'We don’t operate multiple queues. We provide each and every customer a dedicated account manager. So if you ever encounter an issue or query with your Internet Leased line, one call to your account manager or our dedicated support team is all it takes to find resolution.' },
      { question: 'What Service Level Agreement can I expect from an Internet Leased Line?', answer: 'As standard, Internet Leased Lines are highly resilient. We offer a 99.985% protected circuit availability SLA. We are aware some ISP’s provide a 100% SLA, however you’d probably find that all service credits will work out similar should you ever encounter an outage.' },
      { question: 'What options are there for backup on Ethernet Leased Lines?', answer: 'We offer all of our customers failover connectivity for their Ethernet Leased Line ranging from ADSL2+, FTTC to an alternative carrier’s Ethernet. Using Cisco technology our failover is provided using HSRP. If we provided one Internet Leased Line over one BTW and the other over Vodafone, both would have their own managed Cisco hardware, mapped with the same IP addresses, failing over to each other in the event of a network outage.' },
      { question: 'What hardware is provided for your Ethernet Leased Lines?', answer: 'Unless stated otherwise all our Ethernet Leased Lines are provided with a managed Cisco router. Which Cisco router is provided will depend on what sized Ethernet Leased Line you take in order to provide optimum performance at all times.' },
      { question: 'How are Ethernet Leased Lines monitored?', answer: 'All of our Ethernet customers Leased Lines are monitored within our NOC 24/7/365 to ensure consistency in performance and immediate response to service issues.' },
      { question: 'How long does it take to install an Ethernet Leased Line?', answer: 'Installation times are subject to survey and can change from order to order, however as standard; Ethernet First Mile can be delivered in 30 working days. Ethernet Leased line can be delivered in 60 working days.' },
      { question: 'Can our Ethernet Leased Line be upgraded?', answer: 'Our customers can upgrade their Ethernet Leased Line speeds at any point. However they may need to consider what their Ethernet Leased Line bearer speed is. For instance if you have a 10Mbps Ethernet Leased Line on a 10Mbps bearer, you are at the maximum speed of the Ethernet Leased Line already. Therefore we would need to install a new connection to meet your requirements. Upgrades are subject to increase in rental charges.' },
      { question: 'Can our existing Fibre be used at site for an Ethernet Leased Line?', answer: 'It’s standard within the industry that all quotations make the assumption that existing fibre is present and available for use to deliver an Ethernet Leased Line. A site survey will be carried out to ascertain whether the correct fibre provisions are available to use. A survey is normally completed immediately after you have placed your order for Ethernet.' },
      { question: 'What is Converged Ethernet?', answer: 'Using Converged Ethernet your business would make cost savings by consolidating voice and data. You can have full confidence in partnering with the market leader in VoIP telephony delivery.' },
      { question: 'What does un-contended Ethernet mean?', answer: 'Ethernet is provided over a dedicated network which is not shared with other businesses. This ensures that your Ethernet Leased Line offers 100% of the bandwidth you’ve been quoted, regardless of times, network restraints and other businesses’ demands.' },
      { question: 'What Ethernet Leased Line speeds are available?', answer: 'We provide Ethernet in different flavours, from 1Mbps up to 10Gbps. Ethernet First Mile range from 1Mbps to 35Mbps, depending on the distance from the exchange. Ethernet Leased lines speed typically range from 10Mbps to 10Gbps.' },
      { question: 'What is an Ethernet Leased Line?', answer: 'An Ethernet Leased Line is a dedicated connection between your premises and the internet. Unlike traditional broadband, Ethernet Leased Lines are uncontended; ensuring you get the bandwidth speeds you have subscribed to. Ethernet Leased Lines are ideal to support applications such as Voice (VoIP), video conferencing and large data transactions.' },
    ],
    selectedFaq: 0,
  }),
}
</script>
